export class RequestForm {

	constructor() {
		this.btn = $('.btn-request');
		this.form = $('.form-request');

		this.actions();
	}

	actions() {

		this.btn.on('click', () => {
			this.form.toggleClass('is-form-request-visible');
		});

	}

}


// WEBPACK FOOTER //
// ./src/js/modules/request.js